import { render, staticRenderFns } from "./bind-wx.vue?vue&type=template&id=37ce7f2a&scoped=true&"
import script from "./bind-wx.vue?vue&type=script&lang=js&"
export * from "./bind-wx.vue?vue&type=script&lang=js&"
import style0 from "./bind-wx.vue?vue&type=style&index=0&id=37ce7f2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ce7f2a",
  null
  
)

export default component.exports